import { z } from 'zod';

/**
 * @see https://app.dev.vestigas.com/redoc#tag/Parsing-Cases/operation/scan_delivery_note_v2_delivery_note_parsing_cases_post
 */
export const zodScanDeliveryNoteResponseSchema = z.object({
  parsingCaseId: z.uuid(),
  parsingCaseIds: z.array(z.uuid()),
});
